module.exports = __webpack_public_path__ + "img/7M.f0435e73.png";